export const MAIL_CAMPAIGN_SELECTION_TYPE = {
  Template: 1,
  Filter: 2
} as const;

export type MailCampaignSelectionType = (typeof MAIL_CAMPAIGN_SELECTION_TYPE)[keyof typeof MAIL_CAMPAIGN_SELECTION_TYPE];
